var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg20180814PatternAdjusted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5264 3384",
    style: {
      enableBackground: "new 0 0 5264 3384"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.3;fill:#56E5E5;}\r\n\t.st1{opacity:0.3;fill:none;stroke:#61ABB2;stroke-width:30;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2427.8,
    cy: 1866.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2568.5,1317.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3061.6,2031.7c0,26.4,21.4,47.9,47.9,47.9c26.4,0,47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2359.2,1317.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2373.9,1375.1c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 2828.2,
    y1: 1660.4,
    x2: 2755.1,
    y2: 1587.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2972.4,1273.7 3013.3,1344.5 2931.5,1344.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1329,
    cy: 1866.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1469.7,1317.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1986.8,2031.7c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1260.4,1317.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1275.1,1375.1c0,26.4,21.4,47.9,47.9,47.9c26.4,0,47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1729.4,
    y1: 1660.4,
    x2: 1656.3,
    y2: 1587.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1878,1254l55.8,96.6c1.9,3.4-0.5,7.5-4.4,7.5h-111.5c-3.9,0-6.3-4.2-4.4-7.5l55.8-96.6 C1871.2,1250.6,1876,1250.6,1878,1254z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 230.3,
    cy: 1866.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.9,1317.1c0-26.4-21.4-47.9-47.9-47.9s-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M888,2031.7c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.6,1317.1c0-26.4-21.4-47.9-47.9-47.9s-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.3,1375.1c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 630.6,
    y1: 1660.4,
    x2: 557.5,
    y2: 1587.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "774.8,1273.7 815.7,1344.5 733.9,1344.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1026.6,1657.8h-99.5c-0.7,0-1.3-0.6-1.3-1.3V1557c0-0.7,0.6-1.3,1.3-1.3h99.5c0.7,0,1.3,0.6,1.3,1.3v99.5 C1027.9,1657.2,1027.3,1657.8,1026.6,1657.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2144.5,1657.8H2045c-0.7,0-1.3-0.6-1.3-1.3V1557c0-0.7,0.6-1.3,1.3-1.3h99.5c0.7,0,1.3,0.6,1.3,1.3v99.5 C2145.8,1657.2,2145.2,1657.8,2144.5,1657.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.1,2161.1l-8.2-24.7c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12.6-38.2 c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12-36.2c-7.8-23.4,5-36.2,28.4-28.4l36.2,12 c23.4,7.8,36.2-5,28.4-28.4l-11.6-35.1c-7.8-23.4,5-36.2,28.4-28.4l22.7,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1446.1,2201.5l-8.2-24.7c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12.6-38.2 c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12-36.2c-7.8-23.4,5-36.2,28.4-28.4l36.2,12 c23.4,7.8,36.2-5,28.4-28.4l-11.6-35.1c-7.8-23.4,5-36.2,28.4-28.4l22.7,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2523.2,2196.4l-8.2-24.7c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12.6-38.2 c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12-36.2c-7.8-23.4,5-36.2,28.4-28.4l36.2,12 c23.4,7.8,36.2-5,28.4-28.4l-11.6-35.1c-7.8-23.4,5-36.2,28.4-28.4l22.7,7.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2427.8,
    cy: 686.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2568.5,137.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3061.6,851.7c0,26.4,21.4,47.9,47.9,47.9c26.4,0,47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2359.2,137.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2373.9,195.1c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 2828.2,
    y1: 480.4,
    x2: 2755.1,
    y2: 407.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2972.4,93.7 3013.3,164.5 2931.5,164.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1329,
    cy: 686.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1469.7,137.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1986.8,851.7c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1260.4,137.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1275.1,195.1c0,26.4,21.4,47.9,47.9,47.9c26.4,0,47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1729.4,
    y1: 480.4,
    x2: 1656.3,
    y2: 407.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1878,74l55.8,96.6c1.9,3.4-0.5,7.5-4.4,7.5h-111.5c-3.9,0-6.3-4.2-4.4-7.5l55.8-96.6 C1871.2,70.6,1876,70.6,1878,74z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 230.3,
    cy: 686.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.9,137.1c0-26.4-21.4-47.9-47.9-47.9s-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M888,851.7c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.6,137.1c0-26.4-21.4-47.9-47.9-47.9s-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.3,195.1c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 630.6,
    y1: 480.4,
    x2: 557.5,
    y2: 407.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "774.8,93.7 815.7,164.5 733.9,164.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1026.6,477.8h-99.5c-0.7,0-1.3-0.6-1.3-1.3V377c0-0.7,0.6-1.3,1.3-1.3h99.5c0.7,0,1.3,0.6,1.3,1.3v99.5 C1027.9,477.2,1027.3,477.8,1026.6,477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2144.5,477.8H2045c-0.7,0-1.3-0.6-1.3-1.3V377c0-0.7,0.6-1.3,1.3-1.3h99.5c0.7,0,1.3,0.6,1.3,1.3v99.5 C2145.8,477.2,2145.2,477.8,2144.5,477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.1,981.2l-8.2-24.7c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12.6-38.2 c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12-36.2c-7.8-23.4,5-36.2,28.4-28.4l36.2,12 c23.4,7.8,36.2-5,28.4-28.4l-11.6-35.1c-7.8-23.4,5-36.2,28.4-28.4l22.7,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1446.1,1021.5l-8.2-24.7c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12.6-38.2 c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12-36.2c-7.8-23.4,5-36.2,28.4-28.4l36.2,12 c23.4,7.8,36.2-5,28.4-28.4l-11.6-35.1c-7.8-23.4,5-36.2,28.4-28.4l22.7,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2523.2,1016.4l-8.2-24.7c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12.6-38.2 c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12-36.2c-7.8-23.4,5-36.2,28.4-28.4l36.2,12 c23.4,7.8,36.2-5,28.4-28.4l-11.6-35.1c-7.8-23.4,5-36.2,28.4-28.4l22.7,7.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 795.3,
    cy: 2991.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M654.7,2442.1c0-26.4,21.4-47.9,47.9-47.9s47.9,21.4,47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.6,3156.7c0,26.4-21.4,47.9-47.9,47.9s-47.9-21.4-47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M864,2442.1c0-26.4,21.4-47.9,47.9-47.9s47.9,21.4,47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M849.3,2500.1c0,26.4-21.4,47.9-47.9,47.9s-47.9-21.4-47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 395,
    y1: 2785.4,
    x2: 468.1,
    y2: 2712.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "250.8,2398.7 209.9,2469.5 291.7,2469.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1894.1,
    cy: 2991.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1753.5,2442.1c0-26.4,21.4-47.9,47.9-47.9c26.4,0,47.9,21.4,47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1236.4,3156.7c0,26.4-21.4,47.9-47.9,47.9c-26.4,0-47.9-21.4-47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1962.8,2442.1c0-26.4,21.4-47.9,47.9-47.9c26.4,0,47.9,21.4,47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1948.1,2500.1c0,26.4-21.4,47.9-47.9,47.9s-47.9-21.4-47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1493.8,
    y1: 2785.4,
    x2: 1566.9,
    y2: 2712.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1345.2,2379l-55.8,96.6c-1.9,3.4,0.5,7.5,4.4,7.5h111.5c3.9,0,6.3-4.2,4.4-7.5l-55.8-96.6 C1352,2375.6,1347.2,2375.6,1345.2,2379z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2992.9,
    cy: 2991.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2852.3,2442.1c0-26.4,21.4-47.9,47.9-47.9c26.4,0,47.9,21.4,47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2335.2,3156.7c0,26.4-21.4,47.9-47.9,47.9c-26.4,0-47.9-21.4-47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3061.6,2442.1c0-26.4,21.4-47.9,47.9-47.9c26.4,0,47.9,21.4,47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3046.9,2500.1c0,26.4-21.4,47.9-47.9,47.9s-47.9-21.4-47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 2592.6,
    y1: 2785.4,
    x2: 2665.6,
    y2: 2712.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2448.4,2398.7 2407.5,2469.5 2489.3,2469.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2196.6,2782.8h99.5c0.7,0,1.3-0.6,1.3-1.3V2682c0-0.7-0.6-1.3-1.3-1.3h-99.5c-0.7,0-1.3,0.6-1.3,1.3v99.5 C2195.3,2782.2,2195.9,2782.8,2196.6,2782.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1078.7,2782.8h99.5c0.7,0,1.3-0.6,1.3-1.3V2682c0-0.7-0.6-1.3-1.3-1.3h-99.5c-0.7,0-1.3,0.6-1.3,1.3v99.5 C1077.4,2782.2,1077.9,2782.8,1078.7,2782.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2817.1,3286.1l8.2-24.7c7.8-23.4-5-36.2-28.4-28.4l-37.2,12.3c-23.4,7.8-36.2-5-28.4-28.4l12.6-38.2 c7.8-23.4-5-36.2-28.4-28.4l-37.2,12.3c-23.4,7.8-36.2-5-28.4-28.4l12-36.2c7.8-23.4-5-36.2-28.4-28.4l-36.2,12 c-23.4,7.8-36.2-5-28.4-28.4l11.6-35.1c7.8-23.4-5-36.2-28.4-28.4l-22.7,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1777.1,3326.5l8.2-24.7c7.8-23.4-5-36.2-28.4-28.4l-37.2,12.3c-23.4,7.8-36.2-5-28.4-28.4l12.6-38.2 c7.8-23.4-5-36.2-28.4-28.4l-37.2,12.3c-23.4,7.8-36.2-5-28.4-28.4l12-36.2c7.8-23.4-5-36.2-28.4-28.4l-36.2,12 c-23.4,7.8-36.2-5-28.4-28.4l11.6-35.1c7.8-23.4-5-36.2-28.4-28.4l-22.7,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M700,3321.4l8.2-24.7c7.8-23.4-5-36.2-28.4-28.4l-37.2,12.3c-23.4,7.8-36.2-5-28.4-28.4l12.6-38.2 c7.8-23.4-5-36.2-28.4-28.4l-37.2,12.3c-23.4,7.8-36.2-5-28.4-28.4l12-36.2c7.8-23.4-5-36.2-28.4-28.4l-36.2,12 c-23.4,7.8-36.2-5-28.4-28.4l11.6-35.1c7.8-23.4-5-36.2-28.4-28.4l-22.7,7.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 4609,
    cy: 1866.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4749.7,1317.1c0-26.4-21.4-47.9-47.9-47.9s-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4540.4,1317.1c0-26.4-21.4-47.9-47.9-47.9s-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4555.1,1375.1c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 5009.4,
    y1: 1660.4,
    x2: 4936.3,
    y2: 1587.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5158,1254l55.8,96.6c1.9,3.4-0.5,7.5-4.4,7.5h-111.5c-3.9,0-6.3-4.2-4.4-7.5l55.8-96.6 C5151.2,1250.6,5156,1250.6,5158,1254z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 3510.3,
    cy: 1866.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3650.9,1317.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4168,2031.7c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3441.6,1317.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3456.3,1375.1c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 3910.6,
    y1: 1660.4,
    x2: 3837.5,
    y2: 1587.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "4054.8,1273.7 4095.7,1344.5 4013.9,1344.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4306.6,1657.8h-99.5c-0.7,0-1.3-0.6-1.3-1.3V1557c0-0.7,0.6-1.3,1.3-1.3h99.5c0.7,0,1.3,0.6,1.3,1.3v99.5 C4307.9,1657.2,4307.3,1657.8,4306.6,1657.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3686.1,2161.1l-8.2-24.7c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12.6-38.2 c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12-36.2c-7.8-23.4,5-36.2,28.4-28.4l36.2,12 c23.4,7.8,36.2-5,28.4-28.4l-11.6-35.1c-7.8-23.4,5-36.2,28.4-28.4l22.7,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4726.1,2201.5l-8.2-24.7c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12.6-38.2 c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12-36.2c-7.8-23.4,5-36.2,28.4-28.4l36.2,12 c23.4,7.8,36.2-5,28.4-28.4l-11.6-35.1c-7.8-23.4,5-36.2,28.4-28.4l22.7,7.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 4609,
    cy: 686.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4749.7,137.1c0-26.4-21.4-47.9-47.9-47.9s-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4540.4,137.1c0-26.4-21.4-47.9-47.9-47.9s-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4555.1,195.1c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 5009.4,
    y1: 480.4,
    x2: 4936.3,
    y2: 407.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5158,74l55.8,96.6c1.9,3.4-0.5,7.5-4.4,7.5h-111.5c-3.9,0-6.3-4.2-4.4-7.5l55.8-96.6 C5151.2,70.6,5156,70.6,5158,74z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 3510.3,
    cy: 686.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3650.9,137.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4168,851.7c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3441.6,137.1c0-26.4-21.4-47.9-47.9-47.9c-26.4,0-47.9,21.4-47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3456.3,195.1c0,26.4,21.4,47.9,47.9,47.9s47.9-21.4,47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 3910.6,
    y1: 480.4,
    x2: 3837.5,
    y2: 407.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "4054.8,93.7 4095.7,164.5 4013.9,164.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4306.6,477.8h-99.5c-0.7,0-1.3-0.6-1.3-1.3V377c0-0.7,0.6-1.3,1.3-1.3h99.5c0.7,0,1.3,0.6,1.3,1.3v99.5 C4307.9,477.2,4307.3,477.8,4306.6,477.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3686.1,981.2l-8.2-24.7c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12.6-38.2 c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12-36.2c-7.8-23.4,5-36.2,28.4-28.4l36.2,12 c23.4,7.8,36.2-5,28.4-28.4l-11.6-35.1c-7.8-23.4,5-36.2,28.4-28.4l22.7,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4726.1,1021.5l-8.2-24.7c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12.6-38.2 c-7.8-23.4,5-36.2,28.4-28.4l37.2,12.3c23.4,7.8,36.2-5,28.4-28.4l-12-36.2c-7.8-23.4,5-36.2,28.4-28.4l36.2,12 c23.4,7.8,36.2-5,28.4-28.4l-11.6-35.1c-7.8-23.4,5-36.2,28.4-28.4l22.7,7.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4075.3,
    cy: 2991.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3934.7,2442.1c0-26.4,21.4-47.9,47.9-47.9s47.9,21.4,47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3441.6,3156.7c0,26.4-21.4,47.9-47.9,47.9c-26.4,0-47.9-21.4-47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4144,2442.1c0-26.4,21.4-47.9,47.9-47.9s47.9,21.4,47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4129.3,2500.1c0,26.4-21.4,47.9-47.9,47.9s-47.9-21.4-47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 3675,
    y1: 2785.4,
    x2: 3748.1,
    y2: 2712.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3530.8,2398.7 3489.9,2469.5 3571.7,2469.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 5174.1,
    cy: 2991.5,
    r: 47.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5033.5,2442.1c0-26.4,21.4-47.9,47.9-47.9s47.9,21.4,47.9,47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4516.4,3156.7c0,26.4-21.4,47.9-47.9,47.9s-47.9-21.4-47.9-47.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5228.1,2500.1c0,26.4-21.4,47.9-47.9,47.9s-47.9-21.4-47.9-47.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 4773.8,
    y1: 2785.4,
    x2: 4846.9,
    y2: 2712.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4625.2,2379l-55.8,96.6c-1.9,3.4,0.5,7.5,4.4,7.5h111.5c3.9,0,6.3-4.2,4.4-7.5l-55.8-96.6 C4632,2375.6,4627.2,2375.6,4625.2,2379z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4358.7,2782.8h99.5c0.7,0,1.3-0.6,1.3-1.3V2682c0-0.7-0.6-1.3-1.3-1.3h-99.5c-0.7,0-1.3,0.6-1.3,1.3v99.5 C4357.4,2782.2,4357.9,2782.8,4358.7,2782.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5057.1,3326.5l8.2-24.7c7.8-23.4-5-36.2-28.4-28.4l-37.2,12.3c-23.4,7.8-36.2-5-28.4-28.4l12.6-38.2 c7.8-23.4-5-36.2-28.4-28.4l-37.2,12.3c-23.4,7.8-36.2-5-28.4-28.4l12-36.2c7.8-23.4-5-36.2-28.4-28.4l-36.2,12 c-23.4,7.8-36.2-5-28.4-28.4l11.6-35.1c7.8-23.4-5-36.2-28.4-28.4l-22.7,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3980,3321.4l8.2-24.7c7.8-23.4-5-36.2-28.4-28.4l-37.2,12.3c-23.4,7.8-36.2-5-28.4-28.4l12.6-38.2 c7.8-23.4-5-36.2-28.4-28.4l-37.2,12.3c-23.4,7.8-36.2-5-28.4-28.4l12-36.2c7.8-23.4-5-36.2-28.4-28.4l-36.2,12 c-23.4,7.8-36.2-5-28.4-28.4l11.6-35.1c7.8-23.4-5-36.2-28.4-28.4l-22.7,7.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg20180814PatternAdjusted);
export default __webpack_public_path__ + "static/media/2018_0814_Pattern_Adjusted.77cb4938d286d1db6b7b0cf463a9244b.svg";
export { ForwardRef as ReactComponent };